module.exports = __webpack_public_path__ + "img/eyes.24456f63.gif";